import api from './api';

export type DocumentoLiberacaoStatus =
  | 'NAO_APLICAVEL'
  | 'NAO_SOLICITADO'
  | 'AGUARDANDO_ENVIO'
  | 'EM_ANALISE'
  | 'APROVADO'
  | 'DEVOLVIDO_CORRECAO'
  | 'CANCELADO';

export type NotaFiscalExecucao = {
  id: string;
  numeroNota: string;
  serie: string;
  chaveAcesso: string;
  valor: number;
};

export type NotaFiscalExecucaoPayload = Omit<NotaFiscalExecucao, 'id'>;

export type DocumentoLiberacao = {
  id?: string;
  emendaId: string;
  planoTrabalhoId?: string;
  disponivelParaSolicitar: boolean;
  motivoIndisponibilidade?: string;
  tipoDocumento?: string;
  orientacao?: string;
  prazoEnvio?: string;
  status: DocumentoLiberacaoStatus;
  vencido: boolean;
  anexoId?: string;
  anexoNome?: string;
  anexoUrl?: string;
  solicitadoPor?: string;
  solicitadoEm?: string;
  enviadoPor?: string;
  enviadoEm?: string;
  analisadoPor?: string;
  analisadoEm?: string;
  observacaoAnalise?: string;
  notasFiscais: NotaFiscalExecucao[];
};

const get = async (emendaId: string): Promise<DocumentoLiberacao> => {
  const response = await api.get(`/emendas/${emendaId}/documento-liberacao`);
  return response.data;
};

const solicitar = async (
  emendaId: string,
  payload: { tipoDocumento: string; orientacao?: string; prazoEnvio: string },
): Promise<DocumentoLiberacao> => {
  const response = await api.post(`/emendas/${emendaId}/documento-liberacao/solicitar`, payload);
  return response.data;
};

const cadastrarNota = async (
  emendaId: string,
  payload: NotaFiscalExecucaoPayload,
): Promise<DocumentoLiberacao> => {
  const response = await api.post(`/emendas/${emendaId}/documento-liberacao/notas`, payload);
  return response.data;
};

const decidir = async (
  emendaId: string,
  decisao: 'APROVAR' | 'DEVOLVER',
  observacao?: string,
): Promise<DocumentoLiberacao> => {
  const response = await api.post(`/emendas/${emendaId}/documento-liberacao/decidir`, { decisao, observacao });
  return response.data;
};

export default { get, solicitar, cadastrarNota, decidir };
